import type { CardInstance, Faction } from '../../types/kotch';

interface DiscardPileDisplayProps {
  discardPile: CardInstance[];
  faction: Faction | null;
  isOpponent?: boolean;
}

export default function DiscardPileDisplay({ discardPile, isOpponent = false }: DiscardPileDisplayProps) {
  const count = discardPile.length;

  return (
    <div className={`kotch-discard-display ${isOpponent ? 'opponent' : 'player'}`}>
      <div className={`kotch-discard-pile ${count === 0 ? 'empty' : ''}`}>
        {count > 0 ? (
          <>
            {count > 2 && <div className="kotch-discard-card stack-3" />}
            {count > 1 && <div className="kotch-discard-card stack-2" />}
            <div className="kotch-discard-card" />
          </>
        ) : (
          <div className="kotch-discard-empty" />
        )}
      </div>
      <div className="kotch-discard-info">
        <span className="kotch-discard-count">{count}</span>
        <span className="kotch-discard-label">Discard</span>
      </div>
    </div>
  );
}
